import React from "react";
import "../Event/Event.css";

const Event = () => {
  return (
    <div className="event-section">
      <div className="left-content">
        <h2>Your Event, Our Priority</h2>
        <p>
          At श्री Var Event & Conference, we specialize in crafting exceptional events that reflect your vision and purpose. 
          Whether it's a corporate events, elegant wedding, product launch, or social gathering, our team ensures every detail is executed flawlessly. 
          From planning to production, we deliver seamless experiences that leave a lasting impression.
        </p>
      </div>
      <div className="right-video">
        <video 
          src="/we.mp4" 
          autoPlay 
          muted 
          loop 
          playsInline 
          preload="metadata"
          width="100%"
          height="auto"
        />
      </div>
    </div>
  );
};

export default Event;
